export function mapToLabelValue(
  data: string[],
): { label: string; value: string }[] {
  return data.map((val) => ({ label: val, value: val }));
}

export function mapNumbersToLabelValue(
  data: number[],
): { label: string; value: string }[] {
  return data.map((val) => ({ label: String(val), value: String(val) }));
}
